import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserService } from '@ddv/entitlements';
import { emptyUserPreferences, UserPreferences } from '@ddv/models';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { catchError, Observable, of } from 'rxjs';

export const userPreferencesResolver: ResolveFn<UserPreferences> = (route): Observable<UserPreferences> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(UserService);

    const clientCode = route.paramMap.get('clientCode') ?? '';
    return service.fetchUserPreferences(clientCode)
        .pipe(catchError((error) => {
            errorCollector.addError(`Failed to load user preferences for client ${clientCode}`, error);
            return of(emptyUserPreferences());
        }));
};
